<template>
  <div class="ip-server-container">
    <IPServerManager :companyUID="companyUID"/> 
  </div>
</template>

<script>

import IPServerManager from "@/views/ip-server/components/ip-server-manager";

export default {
  props:{
    companyUID: String
  },
  components: {
    IPServerManager
  }
};
</script>

<style lang="scss">

</style>